export enum Role {
    parent = 'parent',
    staff = 'staff',
    trustee = 'trustee',
    cald = 'cald'
}
